import { memoize } from '@codeleap/utils'
import Head from 'next/head'
import { React } from '@/config'
import { View, Loading } from '@/components'

export const PageLoading = memoize(() => {
  return (
    <>
      <Head>
        <style>{`html,body{overflow:hidden!important;}`}</style>
      </Head>
      <View style={['center', { position: 'fixed', top: 0, right: 0, bottom: 0, left: 0, overflow: 'hidden' }]}>
        <Loading />
      </View>
    </>
  )
})
